import React from 'react';
import '../styles/AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-image-section">
          <div className="profile-image">
            <img 
              src={require('../assets/profile-photo.jpg')} 
              alt="Vineet M Kelaskar" 
              className="profile-pic"
            />
          </div>
        </div>
        
        <div className="about-content-section">
          <div className="about-header">
            <h1>Greetings</h1>
          </div>
          
          <div className="about-text">
            <p>
              Born and raised in Bengaluru, India, I have always taken every opportunity to explore Mother Nature , whether it's the hills surrounding my city or the state I live in. I have tried every possible way to capture her beauty. Recently, I have started to visit a few ancient temples in her abode, and everything has changed since then.
            </p>
          </div>
          
          <div className="contact-section">
            <h3>Contact</h3>
            <p className="contact-email">
              Email for inquiries, prints, rates: 
              <a href="mailto:vineetmm16@gmail.com">vineetmm16@gmail.com</a>
            </p>
            
            <div className="social-links">
              <a 
                href="https://www.instagram.com/vineet_m_kelaskar?igsh=amd6Z21pNnoyYzZ4" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                Instagram
              </a>
              <a 
                href="https://www.linkedin.com/in/vineet-m-kelaskar-7962b4275/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
